import React from 'react';
import { FaDiscord, FaTelegramPlane, FaGithub, FaSpotify, FaSteam, FaInstagram, FaYoutube } from 'react-icons/fa';
import { SiWakatime, SiRoblox, SiX } from 'react-icons/si';
import './Social.css';

function Social() {
  const socials =[
    { url: 'https://discordapp.com/users/836647735809146930', title: 'Discord', icon: <FaDiscord size={22} /> },
    { url: 'https://t.me/NO_PON_YES_ZROZ', title: 'Telegram', icon: <FaTelegramPlane size={22} /> },
    { url: 'https://github.com/kirilo987', title: 'GitHub', icon: <FaGithub size={22} /> },
    { url: 'https://wakatime.com/@Kxysl1k', title: 'WakaTime', icon: <SiWakatime size={22} /> },
    { url: 'https://open.spotify.com/playlist/62f6bjrz0NRYgtvfFJgMvr', title: 'Spotify', icon: <FaSpotify size={22} /> },
    { url: 'https://steamcommunity.com/profiles/76561199199663656/', title: 'Steam', icon: <FaSteam size={22} /> },
    { url: 'https://www.roblox.com/users/2316543627/profile', title: 'Roblox', icon: <SiRoblox size={22} /> },
    { url: 'https://www.instagram.com/no_pon_yes_zroz/', title: 'Instagram', icon: <FaInstagram size={22} /> },
    { url: 'https://x.com/kxysl1k', title: 'X / Twitter', icon: <SiX size={22} /> },
    { url: 'https://www.youtube.com/@NO_PON_YES_ZROZ', title: 'YouTube', icon: <FaYoutube size={22} /> }
  ];

  return (
      <div className="social-media-container">
        {socials.map((social) => (
            <a key={social.title} href={social.url} target="_blank" rel="noopener noreferrer" title={social.title} style={{ color: '#fff' }}>
              {social.icon}
            </a>
        ))}
      </div>
  );
}

export default Social;